import { render, staticRenderFns } from "./AddClientInstructions.vue?vue&type=template&id=5c11a3d6&scoped=true"
import script from "./AddClientInstructions.vue?vue&type=script&lang=js"
export * from "./AddClientInstructions.vue?vue&type=script&lang=js"
import style0 from "./AddClientInstructions.vue?vue&type=style&index=0&id=5c11a3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c11a3d6",
  null
  
)

export default component.exports